import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-314fe151"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cookie-overlay"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "cookie-text" }, " Para oferecer a melhor experiência possível em nosso site, utilizamos cookies. Ao continuar navegando, você concorda com o uso desses cookies. Eles são essenciais para garantir funcionalidades como o login seguro. Saiba mais em nossa Política de Privacidade. ", -1))

import { ref, onMounted } from "vue";
import { AtomButton } from "@/components/atoms";


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeLGPD',
  setup(__props) {

const allowedCookies = ref(true);

function setCookies(save = false) {
  if (save) document.cookie = "allow_cookies=true";
  allowedCookies.value = true;
}

onMounted(() => {
  setTimeout(() => {
    const cookies = document.cookie.split(";");
    const index = cookies.findIndex((e) => e.includes("allow_cookies"));

    if (index !== -1) {
      setCookies(cookies[index].split("=")[1] !== "true");
      return;
    }

    allowedCookies.value = false;
  }, 1000);
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (!allowedCookies.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_container, {
              fluid: "",
              class: "cookie-container"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  align: "center",
                  class: "cookie-row"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "8" }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AtomButton), {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (setCookies(true))),
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Concordo ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})